export const SEARCH_ORDER_MANAGERS_OPTION_OUTPUT = `
  orderManagers {
    id
    firstName
    lastName
    email
    role
  }
`;
